import SavedPaymentMethods from './SavedPaymentMethods'

export default SavedPaymentMethods
